import { ShowChart, TableView } from "@mui/icons-material"
import { IconButton, Tooltip } from "@mui/material"

type ShowChartAsTableButtonProps = {
  showAsTable: boolean
  onClick: () => void
  testId?: string
}

const ShowChartAsTableButton = ({ showAsTable, onClick, testId }: ShowChartAsTableButtonProps) => {
  return (
    <Tooltip title={showAsTable ? "Show chart" : "Show table"}>
      <span>
        <IconButton data-testid={testId} onClick={onClick}>
          {showAsTable ? <ShowChart color="primary" /> : <TableView color="primary" />}
        </IconButton>
      </span>
    </Tooltip>
  )
}

export default ShowChartAsTableButton
